import { Grid, TextField } from "@material-ui/core";
import { DesktopDatePicker } from "@material-ui/lab";
import cx from "classnames";
import { useField } from "formik";
import React from "react";

const EntryDate = ({
  required,
  label,
  topLabel,
  name,
  inputFormat = "dd/MM/yyyy",
  minDate = new Date("2016-01-01"),
  maxDate,
  // ...
  xs = 12,
  md = 6,
  // ...
  disabled
}) => {
  const [field, meta, helpers] = useField({ name });
  // ...
  return (
    <Grid item xs={xs} md={md}>
      {topLabel && (
        <label
          style={{
            display: "block",
            color: "#333",
            fontFamily: "Poppins, sans-serif",
            fontSize: "13px",
            lineHeight: "20px",
            fontWeight: "500",
            margin: "0 0 5px 0"
          }}>
          {topLabel}
        </label>
      )}
      <DesktopDatePicker
        label={label}
        name={name}
        value={new Date(field.value)}
        onChange={(date) => {
          if(Date.parse(date)){
            const newDate = new Date(meta.value);
            newDate.setFullYear(date.getFullYear());
            newDate.setMonth(date.getMonth());
            newDate.setDate(date.getDate());
            helpers.setValue(newDate);
          }          
        }}
        inputFormat={inputFormat}
        minDate={minDate}
        maxDate={maxDate}
        disabled={disabled}
        // ...
        renderInput={(params) => (
          <TextField
            className={cx("Entry EntryTime", { __required: required })}
            {...params}
            // ...
            error={!!meta.error}
            helperText={meta.error}
            // ...
            // helperText={null}
            fullWidth
            margin="normal"
          />
        )}
      />
    </Grid>
  );
};

export default EntryDate;
